export const DISCOUNT_TYPES = ["fix", "percent"];
